import React from "react"
import Slider from "@kit/design/slider"
import Label from "@kit/design/label"

export function getRatio(ratio, side) {
  if (side === "left") return `${ratio}%`

  if (side === "right") return `${100 - ratio}%`

  throw new Error(`getRatio's second argument must be "left" or "right"`)
}

export function ColumnRatio({
  properties,
  update,
  label = "Column ratio",
  min = 25,
  max = 75,
  step = 5
}) {
  return (
    <div>
      <div className="pb-1">
        <Label>{label}</Label>
      </div>
      <Slider
        id="columnRatio"
        name="columnRatio"
        value={Number(properties.columnRatio)}
        onChange={e => update({ columnRatio: e.target.value })}
        min={min}
        max={max}
        step={step}
      />
    </div>
  )
}
